import { useEffect } from 'react';
import { QueryObserverResult, RefetchOptions } from '@tanstack/react-query';
import useCurrentUser from 'src/api/auth/useCurrentUser';
import CurrentUser from 'src/types/CurrentUser';
import { authzClient } from '@/context/authz/AuthzClient';

interface IUseAuth {
  isFetchingAuthInitialStatus: boolean;
  currentUser?: CurrentUser;
  error?: Error;
  isRefetching: boolean;
  refetchUser: (options?: RefetchOptions) => Promise<QueryObserverResult>;
}

function useAuth(): IUseAuth {
  const {
    data: currentUser,
    error: currentUserError,
    refetch: refetchUser,
    isLoading: isLoadingUser,
    isRefetching: isRefetchingCurrentUser,
    isFetching: isFetchingCurrentUser,
  } = useCurrentUser();

  const user = currentUser?.user;

  useEffect(() => {
    if (user?.abilityRules) {
      // Clear old initial abilities before repopulating with fresh ones
      authzClient.clearInitialAbilities();
      authzClient.initializeFromAbilityRules(user.abilityRules);
    }
  }, [user?.abilityRules]);

  return {
    isFetchingAuthInitialStatus: isLoadingUser && isFetchingCurrentUser,
    currentUser: user || undefined,
    error: currentUserError ? new Error(currentUserError.message) : undefined,
    isRefetching: isRefetchingCurrentUser,
    refetchUser,
  };
}
export default useAuth;
